import React from 'react'
import { useUserPaymentsContextValue } from '../../context/UserPaymentsProvider'
import { PayoutToAchModal } from './PayoutToAchModal'

export const PayoutToAchFlow = () => {
  const {
    state: { payoutToAch },
  } = useUserPaymentsContextValue()

  if (!payoutToAch) {
    return null
  }

  return <PayoutToAchModal />
}
